// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"loadPlanSummary_tableHeader__2bVxK","summaryBox":"loadPlanSummary_summaryBox__3P1_H","error":"loadPlanSummary_error__MjwDI"};